import { action, autorun, computed, makeObservable, observable } from 'mobx';
import { MessengerModel } from './messenger.model';
import { th } from 'date-fns/locale';

export class LinkedMessengersStore {
    messengers: string[] = [];
    readonly messengerControl = new MessengerModel('Оберіть месенджер');
    readonly messengersControls: MessengerModel[] = [];

    constructor() {
        makeObservable(
            this,
            {
                messengers: observable,
                messengersControls: observable,
                setMessengerTypes: action,
                addMessanger: action,
                removeMessenger: action,
            },
            { autoBind: true }
        );
        autorun(() => {
            console.log(this.messengerControl, 'sdf');
        });
    }

    availableMessengers(messenger: MessengerModel) {
        const selected = [...this.messengersControls, this.messengerControl]
            .map((c) => c.selectValue)
            .filter(Boolean);

        return this.messengers.filter((m) => {
            return m === messenger.selectValue || !selected.includes(m);
        });
    }

    setMessengerTypes(massengers: string[]): void {
        this.messengers = massengers;
    }

    addMessanger(messenger: MessengerModel = new MessengerModel('Оберіть месенджер')): void {
        if (this.messengersControls.length < this.messengers.length - 1) {
            this.messengersControls.push(messenger);
        }
    }

    removeMessenger(id: string): void {
        const targetIdx = this.messengersControls.findIndex((m) => m.id === id);
        if (targetIdx >= 0) {
            this.messengersControls.splice(targetIdx, 1);
        }
    }
}
